<template>
  <div class="d-flex">
    <v-switch
      v-if="EXIBIR_COMPRA_POR_FILIAL"
      v-model="COMPRA_DISTRIBUIDA_POR_FILIAL"
      hide-details
      color="#a71830"
    >
      <template #label>
        <span class="pl-2 text-truncate" :class="{'text-white': dark}">Comprar por filial</span>
      </template>
    </v-switch>

    <ConsiderarEstoqueGrupo v-show="COMPRA_DISTRIBUIDA_POR_FILIAL && EXIBIR_COMPRA_POR_FILIAL" :dark="dark" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ConsiderarEstoqueGrupo from "@/components/compra/CompraDistribuidaPorFilial/ConsiderarEstoqueGrupo";

export default {
  name: "HabilitarCompraDistribuidaPorFilial",
  components: {ConsiderarEstoqueGrupo},
  props: {
    cardSelecionado: Object,
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    EXIBIR_COMPRA_POR_FILIAL() {
      return localStorage.filial_compra === 'S' && this.FILIAL_COMPRA === 0;
    },
    ...mapGetters({
      GRUPO_COMPRA: "usuario/getGrupoCompras",
      FILIAL_COMPRA: "usuario/getFilialCompras",
      FORNECEDOR_COMPRA: "fornecedor/getFornecedor",
      COMPRADOR: "fornecedor/getComprador",
    }),
    COMPRA_DISTRIBUIDA_POR_FILIAL: {
      get() {
        return this.$store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'];
      },
      set(valor) {
        this.$store.dispatch('CompraDistribuidaPorFilial/set_distribuir_por_filial', valor);

        if (!localStorage.config_multifilial_considerar_estoque_grupo) {
          this.$store.dispatch('CompraDistribuidaPorFilial/set_considerar_estoque_grupo', true);
        }
      }
    },
    CONSIDERAR_ESTOQUE_GRUPO() {
      return this.$store.getters['CompraDistribuidaPorFilial/get_considerar_estoque_grupo'];
    }
  },
  watch: {
    FILIAL_COMPRA() {
      if (this.FILIAL_COMPRA > 0) {
        this.COMPRA_DISTRIBUIDA_POR_FILIAL = false;
      }
    },
    COMPRA_DISTRIBUIDA_POR_FILIAL() {
      this.atualizarTotaisEListaProdutos();
    },
    CONSIDERAR_ESTOQUE_GRUPO() {
      this.atualizarTotaisEListaProdutos();
    }
  },
  methods: {
    atualizarTotaisEListaProdutos () {
      if (this.$route.path === '/compra') {
        this.cardSelecionado.metodo(this.FORNECEDOR_COMPRA.id);

        this.Helpers.atualizarTotaisGrupo(
          this.FORNECEDOR_COMPRA.id,
          this.GRUPO_COMPRA,
          this.FILIAL_COMPRA,
          this.COMPRADOR.id,
          this.FORNECEDOR_COMPRA.idSegmento
        );
      }
    }
  }
}
</script>

<style scoped>
.k{
  color: #bb2525;
}
</style>
